module.exports = __webpack_public_path__ + "img/4.1fb2180e.jpg";